const S3_SNAPSHOT_BASE = 'https://inferium-public-snapshots.s3.us-east-2.amazonaws.com';

/**
 * Attempts a live API fetch first. If it fails, falls back to an S3 static snapshot.
 * This ensures public reports remain viewable even when the backend is down.
 */
export async function fetchWithS3Fallback<T>(
  liveFetch: () => Promise<T>,
  s3Path: string
): Promise<T> {
  try {
    const result = await liveFetch();
    if (!result) throw new Error('Empty response from live API');
    return result;
  } catch {
    console.warn('Live API unavailable, trying S3 snapshot fallback...');
    const response = await fetch(`${S3_SNAPSHOT_BASE}/${s3Path}`);
    if (!response.ok) throw new Error(`Snapshot not available (${response.status})`);
    return response.json();
  }
}
